import werouter from  "@/router/routerConfig"
const blacklist = [
    {"path":"/index",value:werouter.index, child:false},
    {"path":"/message",value:werouter.message, child:false},
    {"path":"/author",value:werouter.author, child:false},
    {"path":"/authordetail",value:werouter.authordetail, child:true},
    {"path":"/match",value:werouter.match, child:false},
    {"path":"/mine",value:werouter.mine, child:false},
    {"path":"/myproject",value:werouter.myproject, child:false},
    {"path":"/subscript",value:werouter.subscript, child:false},
    {"path":"/userinfo",value:werouter.userinfo, child:false},
    {"path":"/project",value:werouter.project, child:true},
    {"path":"/alipay",value:werouter.alipay, child:false},
    {"path":"/alipayrecharge",value:werouter.alipayrecharge, child:false},
    {"path":"/recharge",value:werouter.recharge, child:false},
    {"path":"/black",value:werouter.black, child:false},
    {"path":"/apppaysucceed",value:werouter.apppaysucceed, child:false},
    {"path":"/webpaysucceed",value:werouter.webpaysucceed, child:false},
    {"path":"/skipblue",value:werouter.skipblue, child:false},
    {"path":"/skipgreen",value:werouter.skipgreen, child:false},
    {"path":"/welogin",value:werouter.welogin, child:false},
    {"path":"/phonelogin",value:werouter.phonelogin, child:false},
    {"path":"/register",value:werouter.register, child:false},
    {"path":"/resetpwd",value:werouter.resetpwd, child:false},
    {"path":"/error",value:werouter.error, child:false},
    {"path":"/slogen",value:werouter.slogen, child:false},
];
export default {
    is_black(path){
        for(let key in blacklist){
            if(blacklist[key].child){
                if(path.indexOf(blacklist[key].path) !== -1 && path.indexOf(blacklist[key].value.temp_path) === -1){
                    return true
                }
            }
            else{
                if(path === blacklist[key].path){
                    return true
                }
            }
        }
        return false
    },
    transRouter(path) {
        for(let key in blacklist){
            if(blacklist[key].child){
                if(path.indexOf(blacklist[key].path) !== -1 && path.indexOf(blacklist[key].value.temp_path) === -1){
                    return path.replace(blacklist[key].path, blacklist[key].value.temp_path)
                }
            }
            else{
                if(path === blacklist[key].path){
                    return blacklist[key].value.path
                }
            }
        }
        return path
    },
    destRouterName(path, name) {
        for(let key in blacklist){
            if(blacklist[key].child){
                if(path.indexOf(blacklist[key].path) !== -1 && path.indexOf(blacklist[key].value.temp_path) === -1){

                    return blacklist[key].value.name
                }
            }
            else{
                if(path === blacklist[key].path){
                    return blacklist[key].value.name
                }
            }
        }
        return name
    },
    is_timestampJump(path){
        let temp = path.match(/\d{13}/g)

        if(temp.length === 1){
            if(temp[0] !== werouter.tail){
                return false
            }
        }
        return true
    },
    timestampRouter(path){
        return path.replace(/\d{13}/g, werouter.tail)
    }
}
